import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import * as Actions from "actions";

import ShopProductSearch from "components/widgets/user/ShopProductSearch";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopProductsList from "components/elements/user/products/ShopProductList";

// Import product detail component
import ShopProductPageDetail from "../../products/ShopProductPageDetail";
import UnifiedSwipeTrigger from "../../../../elements/main/UnifiedSwipeTrigger";

const ShopProductsTabContent = (props) => {
    const [childData, setChildData] = useState('');
    const { shopId, location, history } = props;

    // Memoize the current product page to prevent recalculation on every render
    const currentProductPage = useMemo(() => {
        const path = location.pathname;
        const pathArray = path.split("/");
        
        // For marketplace: /shop/:shopId/products/:prodId
        // For usersite: /products/:prodId
        const baseIndex = process.env.REACT_APP_TYPE === "USERSITE" ? 0 : 2;
        const section = pathArray[baseIndex + 1] || "";
        const subsection = pathArray[baseIndex + 2] || "";
        
        if (section === "products" && subsection && subsection !== "search" && subsection !== "sort") {
            return { type: 'product-detail', productId: subsection };
        }
        return { type: 'products-list' };
    }, [location.pathname]);


    const handleBackToProducts = () => {
        history.push(`/shop/${shopId}/products`);
    };

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleBack = () => {
        history.goBack();
    };

    const renderSubPageHeader = (title) => (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mb: 3,
            pb: 2,
            borderBottom: '1px solid #e0e0e0'
        }}>
            <IconButton 
                onClick={handleBackToProducts}
                sx={{ mr: 2 }}
            >
                <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {title}
            </Typography>
        </Box>
    );

    const renderMainProductsPage = () => {
        return (
            <Box>
                <ShopProductSearch 
                    {...props} 
                    shopId={shopId} 
                    colSize={3} 
                    sendDataToParent={handleDataFromChild} 
                />
            </Box>
        );
    };

    const renderProductFlow = () => {
        switch (currentProductPage.type) {
            case 'product-detail':
                return (
                    <Box>
                        {renderSubPageHeader('Product Details')}
                        <ShopProductPageDetail {...props} hideHeader={true} />
                    </Box>
                );
            default:
                return renderMainProductsPage();
        }
    };

    return (
        <>
            { renderProductFlow() }
            <UnifiedSwipeTrigger onLeftSwipeComplete={() => { handleBack() }} />
        </>
    );

};

ShopProductsTabContent.propTypes = {
    userResetSearchProducts: PropTypes.func.isRequired,
    shopId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

const _ShopProductsTabContent = connect(
    ({ userproducts, bootupInfo }) => ({
        bootupInfo,
        reqStatus: userproducts.reqStatus,
        isLoading: userproducts.isLoading,
        serviceError: userproducts.serviceError,
        categoryList: userproducts.categoryList,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductsTabContent);

export { _ShopProductsTabContent as default };


